export default __webpack_public_path__ + "static/media/partners2.82873342.png";